import React, { useState } from 'react'
import TableDataSSR from './TableDataSSR'
import FormElement from './FormElement'
import Detail from './Detail'

function Stockopname() {
    const [content, setContent] = useState('table')
    const [idShow, setIdShow] = useState('')
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [filters, setFilters] = useState({})
    const [params, setParams] = useState('')

    const showDetail = (id) => {
        setIdShow(id)
        setContent('detail')
    }
    const showTable = () => {
        setContent('table');
    }
    const showForm = (type) => {
        setContent('form' + type);
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (
                    <TableDataSSR
                        showForm={showForm}
                        showDetail={showDetail}
                        indexSetPage={setPage}
                        indexSetRowsPerPage={setRowsPerPage}
                        indexSetParams={setParams}
                        indexSetFilters={setFilters}
                        initialPage={page}
                        initialRowsPerPage={rowsPerPage}
                        initialFilters={filters}
                        initialParams={params}
                    />
                )
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement type="edit" showTable={showTable} />)
            case 'detail':
                return (<Detail showForm={showForm} showTable={showTable} rowId={idShow} />)
            default:
                return <>Nothing to show here</>
        }
    }

    return (
        <>
            {renderContent(content)}
        </>
    )
}

export default Stockopname